<template>
  <pt-lab-test-platform-new class="pt-lab-test-platform-new__page"></pt-lab-test-platform-new>
</template>

<script>
import PtLabTestPlatformNew from 'cps/gene-product/pt-lab-test-platform-new/withData'
export default {
  name: 'pt-lab-test-platform-new__view',
  components: {
    'pt-lab-test-platform-new': PtLabTestPlatformNew
  }
}
</script>
